import { error } from "console";
import {
  UPDATE_EVENT_REQUEST,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAILURE,
  UPDATE_EVENT_EMPTY,
} from "../../../Utils/Constant";

const initialState = {
  data: null,
  loading: false,
  error: null,
  main: null,
};
export const updateEventReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_EVENT_REQUEST:
      return {
        ...state,
        data: action.payload,
        loading: true,
        error: null,
      };
    case UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        main: action.payload,
        error: null,
      };
    case UPDATE_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_EVENT_EMPTY:
      return {
        ...state,
        loading: false,
        error: null,
        main: null,
      };
    default:
      return state;
  }
};
